import React from 'react'
import { Box, CssBaseline } from '@mui/material'
import { Theme } from '@mui/material/styles'
import { makeStyles } from 'tss-react/mui'
import ModalRoot from 'src/Elements/ModalRoot'
import ContentView from './ContentView'
import { useTypedSelector } from 'src/State/RootReducer'

export { pageActionIcons } from './pageActionIcons'

const useStyles = makeStyles()((theme: Theme) => ({
  root: {
    display: 'flex',
    flex: 1,
    minHeight: '100vh',
    height: '100%',
    '&:after': {
      content: '""',
      background: theme.palette.background.application,
      position: 'fixed',
      top: 0,
      left: 0,
      bottom: 0,
      right: 0,
      zIndex: -1,
    },
  },
}))

interface FrameworkViewProps {
  children?: React.ReactNode
}

const FrameworkView: React.FC<FrameworkViewProps> = ({ children }) => {
  const { classes } = useStyles()
  const activeStorage = useTypedSelector(state => state.storage.activeStorage)
  const user = useTypedSelector(state => state.user.userData)

  return (
    <>
      <Box className={classes.root}>
        <CssBaseline />
        <ContentView user={user} activeStorage={activeStorage}>
          {children}
        </ContentView>
      </Box>
      <ModalRoot />
    </>
  )
}

export default FrameworkView
